import styled from 'styled-components';
import primitives from '@veneer/primitives';
const { typography } = primitives;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  font-family: ${typography.family0};

  .title {
    font-size: ${typography.size5};
    line-height: ${typography.lineHeight4};
    font-weight: ${typography.weight4};
  }
  .subtitle {
    font-size: ${typography.size3};
    line-height: ${typography.lineHeight3};
    margin-top: 8px;
  }
  .reload-button {
    margin-top: ${typography.size5};
    height: 40px;
  }
`;
